// PodcastPlayerSpotify.jsx
import React from "react";

export default function PodcastPlayerSpotify({
  episodeId,
  start = 0,            // seconds
  compactOnMobile = true,
  desktopHeight = 352,  // Spotify "full" player height
  mobileHeight = 152,   // Spotify "compact" player height
  title = "Bridge to Bharath – Spotify Player",
}) {
  if (!episodeId) return null;

  const src = `https://open.spotify.com/embed/episode/${episodeId}?t=${start}`;

  return (
    <>
      {/* Responsive height helper */}
      <style>{`
        .spotify-embed {
          width: 100%;
          border: 0;
          border-radius: 12px;
          height: ${desktopHeight}px;
        }
        @media (max-width: 576px) {
          .spotify-embed {
            height: ${compactOnMobile ? mobileHeight : desktopHeight}px;
          }
        }
      `}</style>

      <iframe
        className="spotify-embed"
        src={src}
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        title={title}
      />
      {/* Optional: accessible fallback link if iframes are blocked */}
      <noscript>
        <p>
          Listen on Spotify:&nbsp;
          <a href={`https://open.spotify.com/episode/${episodeId}`} target="_blank" rel="noreferrer">
            open.spotify.com/episode/{episodeId}
          </a>
        </p>
      </noscript>
    </>
  );
}
